import { POST } from '@/api'

const initialState = window.gnaviReserveList || {}

export default {
  namespaced: true,
  state: {
    isSP: false,
    status: null,
    errorMessage: null,
    busy: false,
    editing: false,
    ...initialState,
  },
  mutations: {
    error(state, { message = null, status = null } = {}) {
      if (!message || !state.errorMessage) {
        state.status = status
        state.errorMessage = message && [].concat(message)
      }
    },
    busy(state, busy) {
      state.busy = busy
    },
    editing(state, change) {
      state.editing = change
    },
  },
  actions: {
    /**
     * ログアウト
     */
    async logout({ state, commit }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/logout')
      if (status === 200) {
        commit('editing', false)
      } else {
        commit('app/error', { status, message }, { root: true })
        commit('busy', false)
      }

      return status === 200
    },
  },
}
